import cx from 'classnames';
import styles from './index.module.scss';
import LeftHeader from '../Headers/LeftHeader';
import { MockStatus } from '../../../types';
import { useSelector } from 'react-redux';
import { RootState } from '@cp/src/store';
import FailureReports from './FailureReports';

const PostAllocationStatus = (props: { showPreviousAllocation?: boolean }) => {
  const { showPreviousAllocation = false } = props;

  const previousAllocationDetails = useSelector(
    (state: RootState) => state?.fieldAllocation?.previousAllocationDetails
  );

  const currentAllocationDetails = useSelector(
    (state: RootState) => state?.fieldAllocation?.fieldAllocationDetails
  );
  const postAllocationDetails = showPreviousAllocation
    ? previousAllocationDetails
    : currentAllocationDetails;

  const postAllocationStatus = postAllocationDetails?.status?.value;
  const isMockApproved = postAllocationStatus === MockStatus.APPROVED;

  const getHeaderLabel = () => {
    if (isMockApproved) {
      return 'Mock allocation approved';
    }
    return 'Allocation successful';
  };

  return (
    <div
      className={cx(styles.headerContainer, styles.containerBorder, 'flex-1 rounded-[7px] ml-3')}
    >
      <LeftHeader title={getHeaderLabel()} variant="h4" />
      <FailureReports allocationDetails={postAllocationDetails} />
    </div>
  );
};

export default PostAllocationStatus;
